export const translationsPL = {
  AdresKorespondencyjny: 'Adres korespondencyjny',
  AdresyKontrolne: 'Adresy kontrolne',
  AdresyKontrolneRozdzielane: 'Adresy kontrolne rozdzielane średnikami',
  Aktywna: 'Aktywna',
  Aktywne: 'Aktywne',
  Aktywnosc: 'Aktywność',
  Aktywny: 'Aktywny',
  Analityka: 'Analityka',
  Anonimowy: 'Anonimowy',
  AutoGenerowanie: 'Auto generowanie nazwy',
  Blad: 'Błąd',
  BrakCechDlaTypuTowaru: 'Dla tego typu towaru nie ma ustawionej żadnej cechy',
  BrakTypowTowarow: 'W systemie nie zdefiniowano żadnych typów dla towarów',
  Cecha: 'Cecha',
  CechaJuzDodanaDoGrupy: 'Ta cecha już znajduje się w tej grupie',
  Cechy_Definicje: 'Definicje',
  Cechy_Definicje_: 'Cechy',
  Cechy_dla_typow_towarow: 'Cechy dla typów towarów',
  Cechy_Grupy: 'Grupy Cech',
  Cechy_Kanaly_Typy: 'Typy kanałów',
  Cechy_Pliki_Typy: 'Pliki dokumenty typy',
  Cechy_Pliki_Typy_tooltip: 'Możliwe typy dokumentów powiązanych z towarem',
  Cechy_Slowniki: 'Słowniki',
  Cechy_Szablony: 'Szablony opisowe',
  Cechy_Towary_Marki: 'Marki',
  Cechy_Towary_Modele: 'Modele',
  Cechy_towary_typy: 'Cechy dla typów towarów',
  Cechy_Towary_Typy: 'Cechy dla typów towarów',
  Cechy_Towary_Typy_Edycja: 'Typy Towarów',
  Cechy_Towary_Typy_popup_confirm:
    'Dane zostały zmodyfikowane. Czy na pewno wychodzimy bez zapisu?',
  Cechy_Towary_Typy_Warianty_Dostepne: 'Warianty dla typów towarów',
  Cechy_Warianty: 'Warianty',
  Cechy_Zdjecia_Typy: 'Pliki zdjęcia typy',
  Cechy_Zdjecia_Typy_tooltip: 'Możliwe typy zdjęć powiązanych z towarem',
  CechySlownikiDistinctValidationMsg:
    'Nazwy w słowniku nie mogą być takie same',
  CechyTowaryTypyMainPopupRefresh:
    'Czy na pewno chcesz odświeżyć? Wszystkie zmiany zostaną utracone.',
  Cena_modyfikacja_kwota: 'Cena modyfikacja $',
  Cena_modyfikacja_procent: 'Cena modyfikacja %',
  Cena_modyfikacja_procent_dodatkowy: 'VAT %',
  CenaBazowa: 'Cena bazowa',
  CenaBazowaBrutto: 'Cena bazowa brutto',
  CenaBruttoWPln: 'Cena brutto (PLN)',
  CenaBruttoWWalucie: 'Cena brutto (waluta)',
  CenaNowa: 'Nowa cena',
  CenaPoprzednia: 'Poprzednia cena',
  Cennik: 'Cennik',
  Cenniki: 'Cenniki',
  CennikWalutaSymbol: 'Cennik - symbol waluty',
  Ceny: 'Ceny',
  Ceny_przeliczone_sukces: 'Ceny zostały przeliczone',
  CenyBazoweDodaneSuccess: 'Liczba dodanych cen bazowych',
  CenyBazoweImportFailed: 'Poniższe ceny bazowe nie zostały dodane',
  Ciagi: 'Ciągi',
  Ciagi_numeracji: 'Ciągi Numeracji',
  Ciagi_Numeracji: 'Ciągi Numeracji',
  ConfirmDialog: 'Czy na pewno potwierdzasz?',
  Dane_Adresowe: 'Dane Adresowe',
  Dane_podstawowe: 'Dane podstawowe',
  Dane_zaladowane_pomyslnie: 'Dane załadowane pomyślnie',
  DaneInformacyjneORelacjiTowary: 'Dane informacyjne o relacji między towarami',
  Data: 'Data',
  DataDo: 'Data do',
  DataModyfikacji: 'Data modyfikacji',
  DataOd: 'Data od',
  DataUtworzenia: 'Data utworzenia',
  DataWyliczenia: 'Data wyliczenia',
  Definicje: 'Definicje',
  Definiuj: 'Definiuj',
  DodajElementTekst: 'Dodaj element - tekst',
  DodajElementZdjecie: 'Dodaj element - zdjęcie',
  DodajKategorie: 'Dodaj kategorie',
  DodajProdukt: 'Dodaj produkt',
  DodajProduktyExcel: 'Dodaj produkty z MS EXCEL',
  DodajPrzynajmniejJedenWarunek:
    'Dodaj przynajmniej jeden warunek do każdego typu towaru',
  DodajSekcje: 'Dodaj sekcję',
  DodajSekcjeItemy: 'Dodaj grupę elementów sekcji',
  DodajTylkoJednoZdj: 'Możesz dodać tylko 1 zdjęcie',
  DodajZdjecie: 'Dodaj zdjęcie',
  DodanoCechy: 'Cechy zostały dodane',
  DodanoCechyZBledami:
    'Niektóre z cech nie zostały dodane ponieważ cechy nie mogą się powielać',
  DodanoDoListy: 'Dodano do listy',
  DodanoTowary: 'Dodano towary',
  DodatkowyHtml: 'Dodatkowy HTML',
  DodatkowyTekst: 'Dodatkowy tekst',
  DodawanieWariantu: 'Dodawanie wariantu',
  Ean: 'Ean',
  Edycja: 'Edycja',
  Edycja_kategoria_cechy: 'Edycja kategoria cechy',
  Edycja_Towary_Opinie: 'Konfiguracja opinii',
  EdycjaKategorii: 'Edycja Kategorii',
  Email: 'Email',
  Examples: 'Examples',
  ExcelImportTowaryKategorieTypIdNazwa:
    'W pierwszym wierszu zdefiniuj pola: "Typ", "Id" lub/i "Nazwa"',
  ExportTowary: 'Eksportuj zaznaczone towary',
  FacebookAppId: 'Facebook app id',
  File_uploader_drop_msg:
    'Czy na pewno chcesz wgrać nowe pliki? Wszystkie edytowane dane zostaną utracone.',
  File_uploader_row_change_msg:
    'Czy na pewno chcesz zmienić edytowany plik? Wszystkie wprowadzone dane zostaną utracone.',
  FileUploader: 'File uploader',
  Firma: 'Firma',
  FormaPlatnosciId: 'Id płatności',
  FormaPlatnosciNazwa: 'Nazwa',
  Format: 'Format',
  Formy_platnosci: 'Formy płatności',
  Formy_platnosci_dostepne: 'Dostępne formy płatności',
  FTP: 'FTP',
  FTP_directory: 'Ścieżka',
  FTP_login: 'Login',
  FTP_pass: 'Hasło',
  FTP_synchronizacja_aktywna: 'Synchronizacja aktywna',
  FTP_URL: 'Url',
  GenerujKreatoryDoXLSX: 'Generuj opcje kreatora do XLSX',
  GoogleAnalyticsId: 'GA ID',
  GoogleClientId: 'Google client id',
  Grupa: 'Grupa',
  Grupy_Cech: 'Grupy Cech',
  Haslo: 'Hasło',
  HasloGeneruj: 'Generuj',
  HasloPlaceholder: 'Wprowadź nowe hasło',
  HasloValidation:
    'Hasło powinno mieć przynajmniej 7 znaków, zawierać przynajmniej jedną małą literę, dużą literę, cyfrę i znak specjalny',
  HistoriaCen: 'Historia cen',
  Home: 'Home',
  Host: 'Host',
  Id: 'Id',
  Identyfikator: 'Identyfikator',
  IdSprzedawcy: 'Id sprzedawcy',
  Ilosc: 'Ilość',
  Imie: 'Imię',
  ImportsErrorInfo: 'Niestety nie udało się zaimportować ',
  ImportsErrorInfoRecords: ' rekordów',
  ImportTowary: 'Importuj towary',
  Indeks: 'Indeks',
  Info: 'Info',
  InformacjaDodatkowa: 'Informacja dodatkowa',
  Instancje: 'Instancje',
  JednostkaId: 'Jednostka Id',
  JednostkaMiary: 'Jednostka miary',
  JednostkaNazwa: 'Jednostka',
  Jednostki_Miar: 'Jednostki miar',
  JestKreator: 'Posiada kreator',
  Jezyk: 'Język',
  JezykDomyslny: 'Domyślny język',
  Jezyki: 'Języki',
  Jezyki_dostepne: 'Języki dostępne',
  JezykId: 'Id języka',
  Kanal: 'Kanał',
  Kategoria: 'Kategoria',
  KategoriaGlowna: 'Kategoria główna',
  KategoriaGlownaK: 'Przypisz produkty do kategorii głównej',
  KategoriaGlownaSciezkaNazwa: 'Kategoria główna - nazwa ścieżki',
  KategoriaNadrzedna: 'Nadrzędna',
  KategoriaNadrzednaId: 'Kategoria Nadrzędna Id',
  KategoriaPodrzednaError:
    'Nie możesz przypisać kategorii do siebie samej lub podrzędnej',
  KategoriaPodrzednaErrorDel:
    'Nie możesz przenieść towarów do usuwanej kategorii lub do kategorii podrzędnej',
  KategoriaPodrzednaNullErrorDel:
    'Musisz wybrać kategorię, do której przeniesiesz towary z usuwanej kategorii',
  KategoriaWirtualna: 'Kategoria Wirtualna',
  KategoriaAktywna: 'Kategoria Aktywna',
  KategoriaSpecjalna: 'Kategoria Specjalna',
  Kategorie: 'Kategorie',
  Kategorie_Cechy_Definicje: 'Parametry',
  Kategorie_Cechy_Ustawienia: 'Kategorie ustawienia',
  Kategorie_Produktowe: 'Kategorie produktowe',
  Kategorie_Towary_Polacz: 'Towary - przypisywanie do kategorii',
  Kategorie_Ustawienia: 'Kategorie Ustawienia',
  KategorieCechy: 'Kategorie Cechy',
  Kategria: 'Kategoria',
  Key: 'Klucz główny',
  Keywords: 'Słowa kluczowe',
  KlienciLista: 'Lista klientów',
  KluczApi: 'Klucz API',
  KluczCrc: 'Klucz CRC',
  KodPocztowy: 'Kod Pocztowy',
  Kolor: 'Kolor',
  Komentarz_Modernizacja: 'Komentarz modernizacja',
  Komentarz_Oryginalny: 'Komentarz oryginalny',
  Komunikator: 'Komunikator',
  KomunikatorEmailImapPassword: 'Email Imap Password',
  KomunikatorEmailImapPort: 'Email ImapPort',
  KomunikatorEmailImapServer: 'Email ImapServer',
  KomunikatorEmailImapUsername: 'Email Imap Username',
  KomunikatorEmailSmtpPassword: 'Email SmtpPassword',
  KomunikatorEmailSmtpPort: 'Email Smtp Port',
  KomunikatorEmailSmtpSenderEmail: 'Email Smtp Sender Email',
  KomunikatorEmailSmtpSenderName: 'Email Smtp Sender Name',
  KomunikatorEmailSmtpServer: 'Email Smtp Server',
  KomunikatorEmailSmtpUsername: 'Email Smtp Username',
  KomunikatorFacebookOurAuthenticationKey: 'Facebook Our Authentication Key',
  KomunikatorFacebookToken: 'Facebook Token',
  KomunikatorMaytapiInstagramPhoneId: 'Maytapi Instagram Phone Id',
  KomunikatorMaytapiProductId: 'Maytapi Product Id',
  KomunikatorMaytapiProductToken: 'Maytapi Product Token',
  KomunikatorMaytapiWhatsappPhoneId: 'Maytapi Whatsapp Phone Id',
  KoszykGuid: 'Koszyk GUID',
  Koszyki: 'Koszyki',
  Kraje: 'Kraje',
  Kraje_dostepne: 'Kraje dostępne',
  Kreator: 'Kreator',
  KreatorModelGrupa: 'Kreator Model Grupa',
  Kreator_Definicje_Typy: 'Definicje typów',
  Kreator_Konfiguracji: 'Kreator konfiguracji',
  Kreator_Kroki: 'Kroki',
  Kreator_Zestawy_Opcji: 'Zestawy opcji',
  Kreatory_Produktow: 'Kreatory',
  KreatoryDodane: 'Liczba dodanych kreatorów',
  KreatoryFolderImportError: 'Poniższe kreatory nie zostały dodane',
  Krok: 'Krok',
  KrokiTypyNieZnaleziono:
    'Żeby móc wprowadzać kroki do kreatora najpierw zdefiniuj typy',
  KtoZmienil: 'Kto zmienił',
  Kurs: 'Kurs',
  Kursywa: 'Kursywa',
  Kwota: 'Kwota',
  KwotaWPln: 'Kwota (PLN)',
  KwotaWWalucie: 'Kwota (waluta)',
  Link: 'Link',
  Logi: 'Logi',
  Login: 'Login',
  LogIn: 'RACCOON',
  Login_placeholder: 'Login',
  Logowanie: 'Logowanie',
  Lp: 'Lp',
  MaksymalnaIloscSKUDoZakupu: 'Maksymalna ilość SKU do zakupu',
  MaksymalnyCzasZwrotu: 'Maksymalny czas zwrotu',
  //
  EmailKomunikacja: 'Email - komunikacja',
  SmtpHost: 'SMTP Serwer',
  SmtpPassword: 'Hasło',
  SmtpUser: 'Użytkownik',
  SmtpPort: 'Port',
  SmtpSecureSocketOptions: 'Opcje szyfrowania',
  SmtpAdresyKontrolne: 'Adresy kontrolne',
  SmtpFrom: 'Od',
  DzialAdministracjiEmail: 'Dział administracji email',
  DzialHandlowyEmail: 'Dział handlowy email',
  //
  Manager_Plikow: 'Manager Plików',
  MANIFEST_Description: 'MANIFEST Description',
  MANIFEST_Lang: 'MANIFEST Lang',
  MANIFEST_Name: 'MANIFEST Name',
  MANIFEST_ShortName: 'MANIFEST ShortName',
  Marka: 'Marka',
  Marki: 'Marki',
  META_Description: 'META Description',
  META_Keywords: 'META Keywords',
  META_Title: 'META Title',
  MetaOpis: 'Meta opis',
  Minimalna_wartosc_to_0001: 'Minimalna wartość to 0.0001',
  Minimalna_wartosc_to_1: 'Minimalna wartosc to 1',
  Model: 'Model',
  Modele: 'Modele',
  Naglowek: 'Nagłówek',
  Nazwa: 'Nazwa',
  Nazwa_Wariant: 'Nazwa',
  NazwaSeo: 'Nazwa SEO',
  NazwaSocial: 'Nazwa Social',
  NazwaSystemowa: 'Nazwa systemowa',
  NazwaSystemowa_Wariant: 'Nazwa Systemowa',
  NazwaTowaru: 'Nazwa Towaru',
  Nazwisko: 'Nazwisko',
  Nie: 'Nie',
  Nieaktywna: 'Nieaktywna',
  NieprawidlowyFormat: 'Nieprawidłowy format',
  NieZdefiniowanoTypowKanalow: 'Nie zdefiniowano typów kanałów',
  NoData: 'Brak danych',
  Notatki: 'Notatki',
  NotifyBrakCech: 'W systemie nie zdefiniowano żadnej cechy',
  NotifyNotAllowedItems: 'Można dodać pliki tylko z rozszerzeniami takimi jak:',
  NrWiersza: 'Nr wiersza',
  NumerOstatnioWykorzystany: 'Numer ostatnio wykorzystany',
  OauthKlientId: 'OAuth client id',
  OauthKlientSecret: 'OAuth client secret',
  Ocena: 'Ocena',
  Odlacz: 'Odłącz',
  Odpowiedz: 'Odpowiedz...',
  Odrzuc: 'Odrzuć',
  Ogolne: 'Ogólne',
  Ok: 'Ok',
  Opcja: 'Opcja',
  Opcje: 'Opcje',
  Opinia: 'Opinia',
  Opis: 'Opis',
  Opis_Wariant: 'Opis',
  Opisany: 'Opisany',
  OpisDodatkowy: 'Dodatkowy opis',
  Opisywanie: 'Opisywanie',
  Opisywanie_towarow: 'Opisywanie Towarów',
  Otworz_wiadomosc: 'Otwórz wiadomość',
  Parametry: 'Parametry',
  Password_placeholder: 'Hasło',
  Plik: 'Plik',
  Pliki: 'Pliki',
  PlikImportowyPrzykladPobierz: 'Pobierz przykładowy plik',
  PlikowZostalo: 'Plików do przesłania zostało',
  Podglad: 'Podgląd',
  Pogrubienie: 'Pogrubienie',
  PokazArchiwalne: 'Pokaż archiwalne',
  PokazCenePrzekreslona: 'Pokaż cenę przekreśloną',
  PokazHtml: 'Pokaz zawartość HTML',
  PokazSzczegoly: 'Pokaż szczegóły',
  Polacz: 'Połącz',
  PolaczZKat: 'Połącz produkty z wybraną kategorią',
  OdlaczZKat: 'Odłącz produkty od wybranej kategorii',
  Pole: 'Pole',
  Polprodukt: 'Półprodukt',
  StatusNowosc: 'Status Nowość',
  StatusTop: 'Status Top',
  StatusNajlepszaCena: 'Status Najlepsza Cena',
  Popularnosc: 'Popularność',
  Port: 'Port',
  PowiadomieniaDlaKlientow: 'Powiadomienia dla klientów',
  Powiazania_Produktowe: 'Powiązania produktowe',
  PowiazaniaNieUdaloSie: 'Nie udało się wprowadzić poniższych powiązań',
  PowiazanoKreatoryZTowarami: 'Liczba wprowadzonych powiązań',
  Priorytet: 'Priorytet',
  Produkty: 'Produkty',
  PromocjaZmianaTypuConfirmMsg: 'Czy na pewno chcesz zmienić typ promocji?',
  Promocje: 'Promocje',
  PrzedOpisaniemTowaruWybierzJegoTyp:
    'Przed opisaniem towaru wybierz jego typ na liście towarów',
  Przelicz_ceny: 'Przelicz ceny',
  Przelicz_ceny_confirm: 'Czy na pewno chcesz przeliczyć wszystkie ceny?',
  PrzetwarzamDane: 'Przetwarzam dane...',
  PrzypisaneSklepy: 'Przypisane konta',
  Receptura: 'Receptura',
  RejectDialog: 'Czy na pewno odrzucasz?',
  Reklamy: 'Reklamy',
  ResetTyp: 'Typ resetu',
  ResourceKey: 'Resource key',
  ResourceType: 'Resource type',
  Rodzaj: 'Rodzaj',
  ModelReprezentant: 'Reprezentant Modelu',
  SortowanieNaLiscieProduktowej: 'Sortowanie Na Liście Produktowej (modele główne dla kategorii)',
  KategoriaGlownaKolejnoscWyswietlaniaNaLiscieProduktowej: 'Sortowanie Na Liście Produktowej (produkty wybrane dla kategorii)',
  RolaUzytkownika: 'Rola użytkownika',
  RouteLp: 'Lp ścieżki',
  Routes: 'Routes',
  SchowajHtml: 'Schowaj zawartość HTML',
  SciezkaNazwa: 'Nazwa ścieżki',
  Seo: 'Seo',
  SeoAlt: 'SEO Alt',
  SeoMetaDescription: ' SEO Meta Description',
  SeoMetaKeywords: ' SEO Meta Keywords',
  SeoMetaTitle: ' SEO Meta Title',
  SeoName: 'SEO Name',
  SeoTitle: 'SEO Title',
  SiteHrefLang: 'Site Href Lang',
  SiteUrl: 'Site Url',
  Sklep: 'Konto',
  SklepNazwa: 'Nazwa konta',
  Sklepy: 'Konta',
  SklepyTowaryWykluczenia: 'Wykluczenia na kontach',
  Slowniki: 'Słowniki',
  SlownikNazwa: 'Słownik',
  Status: 'Status',
  StatusOpisania: 'Status opisania',
  Stopka: 'Stopka',
  StopkaInformacjaDodatkowa: 'Informacja dodatkowa',
  Strony_Statyczne: 'Strony Statyczne',
  StronyStatyczne: 'Strony Statyczne',
  StronyStatyczneZmianaJezykaConfirmMsg:
    'Czy na pewno chcesz zmienić język? Zmiany zostaną utracone.',
  Successful_upload_msg: 'Pomyślnie wysłano pliki',
  Symbol: 'Symbol',
  Szablony_Wiadomosci: 'Szablony Wiadomości',
  SzablonyCechyDostepne: 'Cechy dostępne',
  SzablonyWariantyDostepne: 'Warianty dostępne',
  Szukaj: 'Szukaj',
  SzukajPlaceholder: 'Szukaj...',
  Tak: 'Tak',
  Tekst: 'Tekst',
  TekstDlaPrzycisku: 'Tekst dla przycisku',
  TekstTlumaczenia: 'Tekst tłumaczenia',
  Telefon: 'Telefon',
  Template: 'Szablon',
  Tlo: 'Tło',
  Tlumaczenia: 'Tłumaczenia',
  TlumaczeniaDodaneSuccess: 'Liczba dodanych tłumaczeń',
  TlumaczeniaImportFailed: 'Poniższe tłumaczenia nie zostały dodane',
  TlumaczeniaSeo: 'Tłumaczenia SEO',
  TlumaczenieId: 'Id tłumaczenia',
  Towar: 'Towar',
  TowarId: 'Id towaru',
  TowarImportDodanoUsunieto: 'Liczba towarów które dodano/usunięto:',
  TowarImportZaktualizowano: 'Liczba zaktualizowanych wartości:',
  TowarIndeks: 'Indeks towaru',
  TowarIndeksPowiazany: 'Indeks powiązany',
  TowarNazwa: 'Nazwa towaru',
  TowarNiePowiazanyZeSoba: 'Towar nie może być powiązany sam ze sobą',
  TowarPodstawowy: 'Towar podstawowy',
  TowarPowiazany: 'Towar powiązany',
  Towary: 'Towary',
  Towary_Import_Export: 'Import - export',
  Towary_Kategorie_Polacz: 'Przypisywanie do kategorii',
  Towary_Lista: 'Towary Lista',
  Towary_Opinie: 'Towary Opinie',
  Towary_Powiazania: 'Towar - towar',
  Towary_Powiazania_Warunki: 'Wg. warunków',
  Towary_Powiazania_Wspolne: 'Wg. cech wspólnych',
  TowaryCena: 'Ceny bazowe',
  TowaryDodaneSuccess: 'Liczba dodanych towarów',
  TowaryImportExcelBlad: 'Poniższe towary nie zostały dodane',
  TowaryImportExportExcelBlad: 'Poniższe towary nie zostały zaktualizowane',
  TowaryImportFailed: 'Poniższe towary nie zostały dodane',
  TowaryLista: 'Lista towarów',
  TowaryPowiazaniaAutoGen: 'Towary powiązania',
  TowaryPowiazaniaWarunkiWybierzOba:
    'Musisz wybrać towar podstawowy i powiązany',
  TowaryPowiazaniaZaMaloTypowTowarow:
    'Musisz wprowadzić co najmniej dwa typy towarowe do systemu żeby dodać powiązania dla typów towarów',
  TowaryWarunkiCechyNotFound: 'Nie znaleziono cech dla powyższego typu towaru',
  Transakcje: 'Transakcje',
  Tresc: 'Treść',
  Typ: 'Typ',
  TypNazwa: 'Nazwa typu',
  TypPodstawowy: 'Typ podstawowy',
  TypPowiazany: 'Typ powiązany',
  TypTowaru: 'Typ towaru',
  Typy_Towarow: 'Typy Towarów',
  Tytul: 'Tytuł',
  URL: 'URL',
  UrlDomyslny: 'Domyślny URL',
  UrlPowiadomienia: 'URL powiadomienia',
  UrlSzablon: 'Szablon URL',
  UserBOBrakEdycji: 'Nie możesz edytować tego użytkownika',
  UserBOBrakUsuniecia: 'Nie możesz usunąć tego użytkownika',
  UsunKategorie: 'Usuń kategorię',
  UsunKategorieDoJakiej: 'Do jakiej kategorii przenieść towary?',
  UsunPlik: 'Usuń plik',
  UsunPlikConfirm: 'Czy na pewno chcesz usunąć ten plik?',
  UsunRekordConfirm: 'Czy na pewno chcesz usunąć ten rekord?',
  UsunRekordKreator: 'Czy na pewno chcesz usunąć kreator dla tego modelu?',
  UsunRekordKrokOpcjaConfirm:
    'Czy na pewno chcesz usunąć tę opcję? Wszystkie jej relacje zostaną usunięte.',
  UsunZdjecie: 'Usuń zdjęcie',
  Uwagi: 'Uwagi...',
  UzupelnijWszystkiePolaImportXlsx:
    'Uzupełnij wszystkie pola w arkuszu wg. przykładu',
  UzupelnijWszystkieWarunki:
    'Uzupełnij wszystkie warunki dla danego typu towaru',
  Uzytkownicy: 'Użytkownicy',
  Uzytkownicy_Backoffice: 'Użytkownicy Back Office',
  Uzytkownicy_Web: 'Użytkownicy Web',
  Uzytkownik: 'Użytkownik',
  UzywaZdjecia: 'Używaj zdjęcia z wariantów',
  KrokGlowny: 'Krok główny',
  KrokGlownyLp: 'Krok główny Lp',
  Waluta: 'Waluta',
  Waluty: 'Waluty',
  Wariant: 'Wariant',
  WariantNazwa: 'Nazwa',
  WariantOpis: 'Opis',
  WariantTyp: 'Typ',
  Warianty: 'Warianty',
  Warianty_dla_typow_towarow: 'Warianty dla typów towarów',
  Wartosc: 'Wartość',
  Wartosc_przekreslona: 'Wartość przekreślona',
  WarunkiPowiazania: 'Warunki',
  Wiadomosci: 'Wiadomości',
  WiadomosciSzablony: 'Szablony tekstowe',
  Wielkosc: 'Wielkość',
  Wlasciwosci: 'Właściwości',
  WprowadzonaWartosc: 'Wprowadzona wartość',
  WprowadzoneDaneNieSaFormatemJson: 'Wprowadzone dane nie są formatem JSON',
  WprowadzPoprawneDane: 'Wprowadź poprawne dane',
  WWW: 'WWW',
  WybierzCeche: 'Wybierz cechę...',
  WybierzKategorie: 'Wybierz kategorię...',
  WybierzTowarRequired: 'Musisz wybrać jakiś towar',
  WyliczenieInfo: 'Wyliczenie info',
  Wymagane: 'Wymagane',
  Wynik: 'Wynik',
  WystawianieOpiniModel: 'Wystawienie opinii model',
  WystawianieOpiniWymaganaModeracja: 'Wystawienie opinii wymagana moderacja',
  YandexMetricaId: 'Yandex Metrica Id',
  Zaakceptuj: 'Zaakceptuj',
  ZabezpieczeniePrzedZbytNiskaCena: 'Przed zbyt niską ceną',
  ZabezpieczeniePrzedZbytNiskaCenaProcent: '% ceny bazowej',
  ZaimportujArkusz: 'Zaimportuj arkusz',
  Zakonczone_pomyslnie: 'Zakończone pomyślnie',
  Zaloguj_header: 'Zaloguj się',
  Zamowienia: 'Zamówienia',
  Zaokraglenie_sposob: 'Zaokrąglenie sposób',
  Zaokraglenie_wspolczynnik: 'Zaokrąglenie współczynnik',
  Zapamietaj_haslo: 'Zapamietaj',
  Zapisano: 'Zapisano',
  Zapisuje: 'Zapisuję',
  Zapisz: 'Zapisz',
  ZdefiniujTypKreatora: 'Zdefiniuj co najmniej jeden typ kreatora',
  Zdjecia: 'Zdjęcia',
  Zdjecie: 'Zdjęcie',
  ZestawNazwa: 'Nazwa zestawu',
  ZmianaCenyKwota: 'Kwotowa zmiana ceny',
  ZmianaCenyProcent: 'Procentowa zmiana ceny',
  ZmianaHaslaSmtp: 'Zmiana hasła SMTP',
  Zmien: 'Zmień',
  ZmieniaWygladProduktu: 'Zmienia wygląd produktu',
  ZmienCene: 'Zmień cene',
  TowarEan: 'EAN',
  OpisNaglowek: 'Nagłówek',
  ZmienZbiorczo: 'Zmień zbiorczo',
  OpisywanieZbiorcze: 'Opisywanie zbiorcze',
  AdditionalInfo: 'Informacje dodatkowe',
  GenerujSeo: 'Generuj SEO',
  // GenerujSeoZbiorowo: 'Generuj SEO zbiorowo',
  PoprawnieOddanoDoSynchronizacji:
    'Poprawnie oznaczono transakcje do synchronizacji',
  OznaczDoSynchronizacji: 'Oznacz do synchronizacji',
  WykluczeniaKontImportError: 'Nie udało się zaimportować pliku',
  PomyslnieZaktualizowanoKonto: 'Pomyślnie zaktualizowano konto',
  Miejscowosc: 'Miejscowość',
  WalidacjaKodowPocztowych: 'Walidacja kodów pocztowych',
  DataDostawyLiczbaDni: 'Data Dostawy Liczba Dni',
  DataDostawyOpis: 'Data Dostawy Opis',
  WalidacjaImion: 'Walidacja imion',
  WalidacjaKoduPocztowego: 'Walidacja kodu pocztowego',
  DostawaDomyslnyCzasDostawy: 'Dostawa domyślny czas dostawy',
  DostawaGranicznaGodzinaPakowania: 'Dostawa graniczna godzina pakowania',
  RobotNoIndex: 'Blokuj skanowanie przez roboty',
  PAYU_OAUTH_CLIENT_ID_SANDBOX: 'Sandbox oauth client id',
  PAYU_OAUTH_CLIENT_SECRET_SANDBOX: 'Sandbox oauth client secret',
  PAYU_SANDBOX: 'Sandbox włączony',
  InstancjaTestowa: 'Instancja testowa',
  StopkaInfoLiniaTelefon: 'Stopka infolinia telefon',
  StopkaInfoLiniaEmail: 'Stopka infolinia email',
  StopkaAdresKorespondencyjny: 'Stopka adres korespondencyjny',
  StopkaWhatsAppNumer: 'Stopka WhatsApp numer',
  CenyModelLiczeniaTyp: 'Cena model liczenia',
  ModelPrezentacjiKategorii:"Model Prezentacji Kategorii",
  HtmlBodyPrzedZamknieciemTaga:"Html Body Przed Zamknięciem Taga",
  YandexMetricaAnalizyWlaczone: 'YandexMetrica Analizy Wlaczone',
  FaceBookSiteVerificationCode: 'FaceBookSite Verification Code',
  FaceBookPixelId: 'FaceBook Pixel Id',
  FaceBookPixelWlaczone: 'FaceBook Pixel Wlaczone',
  GoogleSiteVerificationCode: 'Google Site Verification Code',
  GoogleAddEtykietaKonwersji: 'Google Add Etykieta Konwersji',
  GoogleTagManagerId: 'Google Tag Manager Id',
  GoogleFloodlightId: 'Google Floodlight Id',
  GoogleAnalyticsIdsDodatkowe: 'Google Analytics Ids Dodatkowe',
  GoogleAdsId: 'Google Ads Id',
  GoogleAnalyticsAnalizyWlaczone: 'Google Analytics Analizy Wlaczone',
  NaPodstawieCennikaICenyBazowej: 'test test',
  GenerujSeoZbiorowo: 'Generuj SEO zbiorowo',
  Ankiety: 'Ankiety',
  PomyslnieDodanoAnkiete: 'Pomyślnie dodano ankietę',
  BrakDodanychPytan: 'Nie dodano żadnych pytań!',
  Rabaty: "Rabaty",
  RabatProcentowy: "Rabat Procentowy",
  IloscTowarowOd: "Ilość Towarow Od"
};
